import { v4 as uuidv4 } from 'uuid'
export function useBusUtils () {
  function replaceHandler (bus, event, handler) {
    bus.$off(event)
    bus.$on(event, handler)
    return () => {
      dropHandlers(bus, event, handler)
    }
  }

  function dropHandlers (bus, event, handler) {
    bus.$off(event, handler)
  }

  function setHandlerAsPromise (bus, event, handler) {
    return new Promise(function (resolve, reject) {
      bus.$off(event)
      const wrappedHandler = (args) => {
        const response = typeof handler === 'function' ? handler(args) : args
        dropHandlers(bus, event, wrappedHandler)
        resolve(response)
      }
      bus.$on(event, wrappedHandler)
    })
  }

  function emitRoundTripEvent (bus, event, payload) {
    const id = uuidv4()
    const receivedPromise = setHandlerAsPromise(bus, id)
    payload = Object.assign(payload || {}, { _eventIdentifier: id })
    bus.$emit(event, payload)
    return receivedPromise
  }

  function BusHandlerManager () {
    this.toDrop = []
    this.eventCounter = new Map()
  }
  BusHandlerManager.prototype.cleanAll = function () {
    for (let i = 0; i < this.toDrop.length; i++) {
      this.toDrop[i]()
    }
    this.toDrop = []
  }

  BusHandlerManager.prototype.addHandler = function (bus, event, handler) {
    this.toDrop.push(replaceHandler(bus, event, handler))
  }

  BusHandlerManager.prototype.listenRoundTripEvents = function (bus, event, handler) {
    const wrappedHandler = (payload) => {
      const id = payload._eventIdentifier
      delete payload._eventIdentifier
      Promise.resolve(handler(payload)).then(response => {
        bus.$emit(id, response)
      })
    }
    this.toDrop.push(replaceHandler(bus, event, wrappedHandler))
  }

  BusHandlerManager.prototype.setHandlerForXTimes = function (bus, event, handler, times) {
    dropHandlers(bus, event, handler)
    this.toDrop.push(() => {
      dropHandlers(bus, event, handler)
    })
    const wrapper = (args) => {
      handler(args)
      this.eventCounter.set(event, (this.eventCounter.get(event) || 0) + 1)
      if (this.eventCounter.get(event) >= times) {
        dropHandlers(bus, event, wrapper)
        this.eventCounter.set(event, 0)
      }
    }
    bus.$on(event, wrapper)
  }

  return {
    replaceHandler,
    setHandlerAsPromise,
    emitRoundTripEvent,
    dropHandlers,
    BusHandlerManager
  }
}



// WEBPACK FOOTER //
// ./src/commons/busUtils.js